/**
 * Orders tab
 */
export const storedStatus = {
  "notParsed": "initiate",
  "estimate": "ready_to_estimate",
  "parsed": "se_complete",
  "Client Reviewed": "Client Reviewed",
  "Work Requested": "work_requested",
  "Allocated": "work_assigned",
  "Accepted": "accepted",
  "Scheduling": "scheduling_in_process",
  "Scheduled": "customer_is_scheduled",
  "In Progress": "work_in_progress",
  "Completed": "completed",
  "Declined": "declined",
};
export const dislayStatus = {
  "initiate": "Initiate",
  "se_complete": "S.E. Complete",
  "ready_to_estimate": "Ready To Estimate",
  "Client Reviewed": "Client Reviewed",
  "work_assigned": "Work Assigned",
  "accepted": "Accepted",
  "scheduling_in_process": "Scheduling in Process",
  "customer_is_scheduled": "Customer is Scheduled",
  "work_in_progress": "Work in Progress",
  "completed": "Job Completed",
  "declined": "Declined",
  "cancel_work_request": "Cancel Work Request"
};
export const orders = {
  storedStatusOld: {
    notParsed: "New",
    parsed: "Processed",
    "Client Reviewed": "Client Reviewed",
    Allocated: "Allocated",
    Accepted: "Accepted",
    Scheduling: "Scheduling",
    Scheduled: "Scheduled",
    "In Progress": "In Progress",
    Completed: "Completed",
    Declined: "Declined",
  },

  dislayStatusOld: {
    notParsed: "New",
    parsed: "Processed",
    "Client Reviewed": "work_requested",
    Allocated: "Allocated",
    accepted: "Accepted",
    Scheduling: "Scheduling in Process",
    Scheduled: "Customer is Scheduled",
    "In Progress": "Work in Progress",
    Completed: "Job Completed",
    Declined: "Declined",
    "S.E Complete": "se_complete",
    "Cancel Work Request": "cancel_work_request"
  },
  scheduleRequestStatus: {
    work_requested: "Client Reviewed",
    work_assigned: "Allocated",
    accepted: "Accepted",
    scheduling_in_process: "Scheduling",
    customer_is_scheduled: "Scheduled",
    work_in_progress: "In Progress",
    completed: "Completed",
    declined: "Declined",
    se_complete: "S.E Complete",
    cancel_work_request: "Cancel Work Request"
  },
  storedStatus: {
    notParsed: "initiate",
    estimate: "ready_to_estimate",
    parsed: "se_complete",
    'Client Reviewed': "Client Reviewed",
    "work_requested": "Work Requested",
    Allocated: "work_assigned",
    Accepted: "accepted",
    Scheduling: "scheduling_in_process",
    Scheduled: "customer_is_scheduled",
    "In Progress": "work_in_progress",
    Completed: "completed",
    Declined: "declined",
    CancelWork: "cancel_work_request"
  },
  dislayStatus: {
    initiate: "Initiate", //Key : value
    se_complete: "S.E. Complete",
    "S.E Complete": "S.E. Complete",
    ready_to_estimate: "Ready To Estimate",
    "work_requested": "Work Requested",
    "Client Reviewed": "Work Requested",
    work_assigned: "Work Assigned",
    accepted: "Accepted",
    scheduling_in_process: "Scheduling in Process",
    customer_is_scheduled: "Customer is Scheduled",
    "work_in_progress": "Work in Progress",// or condition 
    completed: "Job Completed",
    declined: "Declined",
    "cancel_work_request": "Cancel Work Request",
    Scheduled: "Customer is Scheduled",
    Accepted: "Accepted",
    Allocated: "Work Assigned",
    notParsed: "New",
    parsed: "Processed",
    Scheduling: "Scheduling in Process",
    "In Progress": "Work in Progress",
    Completed: "Job Completed",
    Declined: "Declined",
    "Cancel Work Request": "Cancel Work Request",
  },
  roleId: {
    fo: '8dab2f2a-2866-4527-9b3d-d2237d8d24c8',
    blueTeam: '8dab2f2a-2866-4527-9b3d-d2237d8d24a7',
    estimator: '7dab2f2a-2866-4527-9b3d-d2237d8d24c7',
    qca: '8dab2f2a-2866-4527-9b3d-d2237d8d24c9',
    owner: '8dab2f2a-2866-4527-9b3d-d2237d8d24c7'

  },
  /** Schedule booking */
  status: {
    Available: "Available",
    Allocated: "Allocated",
    Accepted: "Accepted",
    Completed: "Completed",
    Scheduling: "Scheduling",
    Scheduled: "Scheduled",
    "In Progress": "In Progress",
    Declined: "Declined"
  },
  displayBookstatus: {
    Available: "Available",
    Allocated: "Allocated",
    Accepted: "Accepted",
    Completed: "Job Completed",
    Scheduling: "Scheduling in Process",
    Scheduled: "Customer is Scheduled",
    "In Progress": "Work in Progress",
    Declined: "Declined"
  },
  workRequested: 'Work Requested',
};
export const role = {
  fo: 'FO',
  estimator: 'Estimator',
  qca: 'QCA',
  blueTeam: 'Blue Team'
}
export const displayValues = {
  operations: "Operations",
  bug: "Submit a Bug",
  calender: "Calender",
  kpi: "KPI",
  team: "Team Users & Permissions",
  solutionDescription: "View or Edit DB",
  solutionDes: {
    title: "ADD NEW DATABASE ITEM",
    keyword: "Keyword",
    solution: "Solution",
    cost: "Cost",
    drag: 'Drag',
    solutionEstimateEnteredHere: "Create a new solution estimate",
    costOption: "Cost drop down option",
    keyPrimCategory: "Keyword Primary Category",
    keyPhrase: "Keyword Phrase",
    Key1: "Keyword 1",
    key2: "Keyword 2",
    key3: "Keyword 3",
    key4: "Keyword 4",
    primaryCategory: "Primary Category",
    subcategory: "Select SubCategory",
    subcate: "SubCategory",
    irl: "Internal Resource Links",
    submitBtnText: "ADD/SAVE New DB ITEM",
    viewEstimate: "VIEW TABLE",
    openAndViewCurrentDBITem: "OPEN AND VIEW / EDIT CURRENT DATABASE",
    updateDescription: "Update Solution",
    update: "COMPLETE EDIT TO DB",
    close: "CLOSE",
    noList: "No solution database item found",
    noSearchFoundAndSuggesstion: 'No matches found. Here are our suggestions..',
    beforeSearch: "Please fill any field to search",
    costOptions: {
      tm: 'T&M',
      manual: 'Manual Entry',
      Flat: 'Flat Rate',
      foot: 'by the foot'
    },
    tableColumn: {
      primaryCategory: "Primary",
      keyword: "Keyword",
      solution: "Solution",
      cost: "Cost",
      costOption: "Cost Option",
      keyPhrase: "KW Phrase",
      subCategory: "Sub",
      Key1: "KW 1",
      key2: "KW 2",
      key3: "KW 3",
      key4: "KW 4",
      link: "IRL",
      edit: "Edit",
      SE: 'Select & Edit',
      select: 'Select Solution',
      editThisSolutionInDB: "Edit Solution",
      delete: "Delete"
    },
    searchSolution: {
      searchTabTitle: "Keyword Search Criteria",
      searchTitle: "Database Search For Solution ",
      searchOptionsTitle: "Solution Estimate Options",
      seacrchDatabaseButton: "SEARCH",
      reset: 'Reset',
    }
  },
  manageRef: {
    head: "Manage references",
    detailTitle: "Manage references",
    tabs: {
      first: "Companies we serve",
      second: "Testimonial"
    },
    companies: {
      label: "Choose company logo we serve",
      uploadText: " Browse company logo",
      submitBtnText: "Submit",
      clearBtnText: "Clear",
      selectedFileName: "Selected file name(s) are"
    },
    testimonials: {
      label: "Choose your picture",
      uploadText: " Browse your picture",
      selectedFileName: "Selected file",
      quotes: "Enter your quotes",
      quotesPlaceHolder: "Quotes"
    },
    noList: "No list",
    delete: "Delete",
    deleteConfirm: "Are you sure you want to remove ?",
    deleteHead: "Confirm",
    deleteOk: "Yes",
    deleteCancel: "Cancel"
  },
  addNew: "Add new order",
  archivedHead: "Archived orders",
  customerToggleRequest: "Requested work",
  pros: "Pros",
  user: "User Info",
  userHead: "Pro User Info",
  noProUser: "No pro user",
  payment: "Payment Info",
  invite: "Invite Pro",
  reviews: "Reviews",
  reviewsHead: "Pro's Reviews",
  uploadDocument: "Documents",
  bgCheck: "Background Check",
  license: "License",
  id: "Id Proof",
  insurance: "Insurance Certificate",
  view: "View",

  bottomHead: "Marketing",
  promoCode: "Promotion Codes",
  eblast: "Send eBlast",
  webinar: "Webinar Sign up List",
  fb: "Post to Facebook",
  toYoutube: "Upload to YouTube",
  toSite: "Upload video to site",

  liveOrder: "spekwo Live Order Feed",
  tableColumn: {
    name: "Customer",
    address: "Subject Property Address",
    order: "Product Ordered",
    date: "Order Date",
    dueDate: "Due Date",
    status: "Status",
    view: "View/Work on Solution Estimate",
    orderDetails: "Order Details",
    reqWork: "Requested work",
    whatToDo: "What to do?",
    assign: "Work Assigned to?",
    toAssign: "pro-work",
    afterAssign: "Assigned",
    ordersrequested: "Orders Requested For",
    archive: "Archive",
    edit: 'Edit',
  },
  archiveBtnText: "Archive orders",
  archiveHeaderText: "Archived orders",
  unArchiveBtnText: "Un archived order",
  orderDetails: "Order Details",
  orderDetailsColumn: {
    agentName: "Customer Name",
    agentType: "Agent Type",
    agent: "Agent Name",
    agentEmail: "Agent Email",
    contact: "Contact info of Agent",
    propertyAdd: "Subject Property Address",
    product: "Product Ordered",
    specificItems: "Specific Items Requested",
    dueDate: "Due Date",
    clientRole: "Client Role",
    clientName: "Buyer or Seller Name",
    addEmail: "Additional Email to send S.E.",
    payment: "Payment",
    unarchive: "Un archive",
    edit: 'Edit',
  },
  customerToggleRequestHeaderText: "Requested work",
  customerToggleRequestColumn: {
    orderId: "Order Id",
    scheduleRequestDate: "Schedule Completion Date",
    contactName: "Contact Name",
    contactEmail: "Contact Email",
    contactPhone: "Contact Phone",
    additionalShare: "Additional Share",
    propertyAddress: "Property Address",
    agentName: "Agent Name ",
    detailsButton: "Details",
    insReportId: "Report Id",
  },
  DetailDialogLabelsName: {
    details: "Details",
    orderId: "Order Id",
    address: "Address",
    agentName: "Agent Name",
  },

  walkArea: "Areas to Inspect",
  walkAreaAdditional: "Additional items to Inspect",
  spekCall: "Available categories",
  noPdf: "No pdf file uploaded",
  paidAt: "Paid at time of order",
  downloadInvoice: "Download/Open Invoice",
  downloadReceipt: "Recepit Link",
  stripeInvoice: "Stripe invoice to customer",
  open: "AWAITING PAYMENT",
  paid: "CLIENT PAID",
  amountPopupLabel: "Please ensure final amount to send invoice",
  amountSubmitBtn: "Send Invoice",
  amountCancelBtn: "Close",
  emailPopupContent: "Email id the link was sent to is",
  noInvoiceEmail: "No specify email given. Used billing email",
  videoColumn: {
    title: "Title",
    desc: "Description",
    video: "Video",
    tags: "Tags"
  },
  noVideo: "No video uploaded",
  uploadVideo: "Upload video to Youtube",
  titleReq: "Title is required!",
  descReq: "Description is required!",
  browse: "Browse",
  upload: "Upload",
  clear: "Clear file",
  uploading: "Uploading...",

  /**Define folder name from backend where uploading document stored */
  bgCheckFolder: "bgCheck",
  licenseFolder: "license",
  idFolder: "Id",
  insuranceFolder: "insurance"
};

export const toolTip = {
  menu: "click to open sidebar",
  manualUpload: "Click to upload Home Inspection file",
  addNew: "Click to add single row",
  addMore: "Click to add 10 rows",
  clearRow: "Click to clear a form data",
  drag: "Drag me",
  remove: "Remove entry",
  openImg: "Click to view image",
  addSubCate: "Click to add subcategory fo this category",
  uploadVideo: "Click to upload new video",
  homeInsReport: "Click to view home inspetcion report",
  ddra: "Click to view DDRA report",
  uniqueReport: "Click to view Unique report",
  preListPictures: "Click to view preList Pictures",
  printScheduling: 'Click to view Scheduling Info',
  supportingReport: "Click to view Supporting Report",

  addSolution: "Click to add solution to database",
  viewEstimate: "Click to view cost estimation table",

  // request work page 
  approveSolutionEstimate: "Click to view Approve Solution Estimate",
  proSolutionEstimate: "Click to view Pro Solution Estimate",

};

// Set background color code for orders on orders list
export const orderStatus = [
  {
    id: "Initiate", //This id should match with 'dislayStatus' value
    name: "Initiate", //For display purposes
    color: "mat-orange-800-bg"
  },
  {
    id: "Ready To Estimate",
    name: "Ready To Estimate",
    color: "mat-blue-500-bg"
  },
  {
    id: "S.E. Complete",
    name: "S.E. Complete",
    color: "mat-blue-500-bg"
  },
  {
    id: "Work Requested",
    name: "Work Requested",
    color: "mat-deep-purple-500-bg"
  },
  {
    id: "Allocated",
    name: "Allocated",
    color: "mat-pink-500-bg"
  },
  {
    id: "Declined",
    name: "Declined",
    color: "mat-red-500-bg"
  },
  {
    id: "Cancel Work Request",
    name: "Cancel Work Request",
    color: "mat-red-500-bg"
  },
  {
    id: "Work in Progress",
    name: "Work in Progress",
    color: "mat-brown-500-bg"
  },
  {
    id: "Customer is Scheduled",
    name: "Customer is Scheduled",
    color: "mat-teal-500-bg"
  },
  {
    id: "Scheduling in Process",
    name: "Scheduling in Process",
    color: "mat-grey-600-bg"
  },
  {
    id: "Work Assigned",
    name: "Work Assigned",
    color: "mat-light-green-800-bg"
  },
  {
    id: "Accepted",
    name: "Accepted",
    color: "mat-light-green-800-bg"
  },
  {
    id: "Job Completed",
    name: "Job Completed",
    color: "mat-green-800-bg"
  }
];

export const newOrderStatus = [
  {
    key: "Initiate",
    Value: "initiate",
  },
  {
    key: "S.E. Complete",
    Value: "se_complete",
  },
  {
    key: "Client Reviewed",
    Value: "Client Reviewed",
  },
  {
    key: "Allocated",
    Value: "work_assigned",
  },
  {
    key: "Declined",
    Value: "declined",
  },
  {
    key: "Work in Progress",
    Value: "work_in_progress",
  },
  {
    key: "Customer is Scheduled",
    Value: "customer_is_scheduled",
  },
  {
    key: "Scheduling in Process",
    Value: "scheduling_in_process",
  },
  {
    key: "Accepted",
    Value: "accepted",
  },
  {
    key: "Job Completed",
    Value: "completed",
  },
  {
    key: "Ready To Estimate",
    Value: "ready_to_estimate",
  },
  // below status for order details status show 
  {
    key: "Scheduled",
    Value: "ready_to_estimate",
  }
];

/**
-----schedulerequest-----
    Client Reviewed
    Allocated
    Accepted
    Completed

-----schedulebooking-----
    Available
    Allocated
    Accepted
*/

export const editOrders = {
  title: 'Order Details Edit',
  requireds: {
    emailRequired : 'Email Required',
    addressRequired: 'Address Required',
    cityRequired: 'City Required',
    stateRequired: 'State Required',
    postCodeRequired: 'Pincode Required',
    custNameRequired: 'Customer Name Required',
    agentNameRequired: 'Agent Name required',
    agentEmailRequired: 'Agent Email required',
    agentPhoneRequired: 'Agent Phone required',
    additionalEmailRequired: 'Additial Email To S.E Required',
    clientNameRequired: 'Client Name Required',
    clientRoleRequired: 'Client Role Required',
    agentTypeRequired: 'Agent Type Required',
  },
  save: 'Save',
  placeHolder: {
    email : 'Email',
    address: 'Address',
    city: 'City',
    state: 'State',
    postcode: 'Pincode',
    customerName: 'Customer Name',
    agentName: 'Agent Name',
    agentEmail: 'Agent Email',
    agentPhone: 'Agent Phone',
    agentType: 'Agent Type',
    clientName: 'Client Name',
    clientRole: 'Client Role',
    additialEmailToSe: 'Additional Email To S.E',
  }
}
export const states = [
  { viewValue: 'Alabama', value: 'Alabama' },
  { viewValue: 'Alaska', value: 'Alaska' },
  { viewValue: 'Arizona', value: 'Arizona' },
  { viewValue: 'Arkansas', value: 'Arkansas' },
  { viewValue: 'California', value: 'California' },
  { viewValue: 'Colorado', value: 'Colorado' },
  { viewValue: 'Connecticut', value: 'Connecticut' },
  { viewValue: 'Delaware', value: 'Delaware' },
  { viewValue: 'Florida', value: 'Florida' },
  { viewValue: 'Georgia', value: 'Georgia' },
  { viewValue: 'Hawaii', value: 'Hawaii' },
  { viewValue: 'Idaho', value: 'Idaho' },
  { viewValue: 'Illinois', value: 'Illinois' },
  { viewValue: 'Indiana', value: 'Indiana' },
  { viewValue: 'Iowa', value: 'Iowa' },
  { viewValue: 'Kansas', value: 'Kansas' },
  { viewValue: 'Kentucky', value: 'Kentucky' },
  { viewValue: 'Louisiana', value: 'Louisiana' },
  { viewValue: 'Maine', value: 'Maine' },
  { viewValue: 'Maryland', value: 'Maryland' },
  { viewValue: 'Massachusetts', value: 'Massachusetts' },
  { viewValue: 'Michigan', value: 'Michigan' },
  { viewValue: 'Minnesota', value: 'Minnesota' },
  { viewValue: 'Mississippi', value: 'Mississippi' },
  { viewValue: 'Missouri', value: 'Missouri' },
  { viewValue: 'Montana', value: 'Montana' },
  { viewValue: 'Nebraska', value: 'Nebraska' },
  { viewValue: 'Nevada', value: 'Nevada' },
  { viewValue: 'New Hampshire', value: 'New Hampshire' },
  { viewValue: 'New Jersey', value: 'New Jersey' },
  { viewValue: 'New Mexico', value: 'New Mexico' },
  { viewValue: 'New York', value: 'New York' },
  { viewValue: 'North Carolina', value: 'North Carolina' },
  { viewValue: 'North Dakota', value: 'North Dakota' },
  { viewValue: 'Ohio', value: 'Ohio' },
  { viewValue: 'Oklahoma', value: 'Oklahoma' },
  { viewValue: 'Oregon', value: 'Oregon' },
  { viewValue: 'Pennsylvania', value: 'Pennsylvania' },
  { viewValue: 'Rhode Island', value: 'Rhode Island' },
  { viewValue: 'South Carolina', value: 'South Carolina' },
  { viewValue: 'South Dakota', value: 'South Dakota' },
  { viewValue: 'Tennessee', value: 'Tennessee' },
  { viewValue: 'Texas', value: 'Texas' },
  { viewValue: 'Utah', value: 'Utah' },
  { viewValue: 'Vermont', value: 'Vermont' },
  { viewValue: 'Virginia', value: 'Virginia' },
  { viewValue: 'Washington', value: 'Washington' },
  { viewValue: 'West Virginia', value: 'West Virginia' },
  { viewValue: 'Wisconsin', value: 'Wisconsin' },
  { viewValue: 'Wyoming', value: 'Wyoming' },
];


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/utils/e-commerce/orders.ts